// this is an autogenerated file from DesignSystem/CaseCloserPaymentPlans/PaymentPlans/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__DesignSystem_CaseCloserPaymentPlans_PaymentPlans($organization_ids: [uuid!]!) {
  treatments_default_payment_plans(
    where: { organization_id: { _in: $organization_ids } }
    order_by: [{ order: asc }]
  ) {
    id
    name
    downpayment
    downpayment_type
    frequency
    discounts {
      id
      type
      value
      stack: stack_with_other_discounts
    }
  }
}

`